/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsNetworkExternalLink: {
  name: 'network-external-link';
  data: string;
} = {
  name: 'network-external-link',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 0 0-1H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V8a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2ZM11 .5a.5.5 0 0 0 0 1h2.793L7.646 7.646a.5.5 0 1 0 .708.708L14.5 2.207V5a.5.5 0 0 0 1 0V1a.5.5 0 0 0-.5-.5h-4Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
